export const calculateSum = (array, property) => {
  let sum = 0;

  array.forEach(element => {
    sum += element[property];
  });

  return sum;
}

export const convertMoney = (value) => {
  let number = value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00";
  return number
}

export const formatPrice = (priceValue) => {
  // Remove all non-digit characters
  const numericValue = priceValue?.replace(/\D/g, '');
  
  // If the numeric value is '0', return '0' to display it
  if (numericValue === '0') {
    return '0';
  }

  if (numericValue === '') {
    return ''
  }

  // Convert to number and then to locale string for formatting (e.g., thousands separator)
  return Number(numericValue).toLocaleString();
}

export const findIndexByDigitCount = (formatted, digitCount) => {
  // hitung posisi index caret berdasarkan jumlah digit di kiri
  if (!formatted || digitCount <= 0) return 0
  let digits = 0
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      digits++
      if (digits === digitCount) {
        return i + 1 // caret setelah digit itu
      }
    }
  }
  return formatted.length
}